import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
export function FailedAttempts() {
  const attempts = [{
    title: 'Guías nutricionales estándar',
    desc: 'Son obsoletas y están influenciadas por las mismas marcas que venden los productos ultraprocesados.'
  }, {
    title: 'Prohibir el dulce',
    desc: 'Solo crea niños ansiosos que terminan comiendo a escondidas en casa de sus amigos o en la escuela.'
  }, {
    title: "Recetas convencionales 'sanas'",
    desc: 'Toman demasiado tiempo de preparación y terminan en un plato rechazado y comida en la basura.'
  }, {
    title: "Confiar en etiquetas 'Natural'",
    desc: "Creer en lo 'Orgánico' u 'Horneado' es caer en la trampa de marketing más cara del supermercado."
  }];
  return <section className="py-14 bg-cream" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-3">
          <div data-id="element-4">
            <FadeIn data-id="element-5">
              <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6 text-center" data-id="element-6">
                Por Qué lo que Has Intentado{' '}
                <span className="text-red-700" data-id="element-7">No Funciona</span>
              </h2>
              <p className="text-lg text-ink/70 mb-8 text-center" data-id="element-8">
                Si te sientes frustrado porque nada parece mejorar los hábitos
                de tu hijo, debes saber que estás luchando contra estrategias de
                marketing diseñadas por expertos para que falles.
              </p>
            </FadeIn>
          </div>

          <div className="space-y-4" data-id="element-9">
            {attempts.map((attempt, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-10">
                <div className="flex items-start space-x-4 bg-white p-6 rounded-2xl shadow-sm border border-ink/5" data-id="element-11">
                  <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-12" />
                  <div data-id="element-13">
                    <h3 className="font-bold text-ink mb-1" data-id="element-14">{attempt.title}</h3>
                    <p className="text-ink/70 text-sm leading-relaxed" data-id="element-15">
                      {attempt.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}